interface DateTimeFormatOptions {
  locale?: string;
  dateStyle?: "full" | "long" | "medium" | "short";
  timeStyle?: "full" | "long" | "medium" | "short";
  hour12?: boolean;
}

interface TimeFormatOptions {
  locale?: string;
  hour?: "numeric" | "2-digit";
  minute?: "numeric" | "2-digit";
  hour12?: boolean;
}

export const formatDate = (
  date: Date,
  options: DateTimeFormatOptions = {}
): string => {
  const defaultOptions: DateTimeFormatOptions = {
    locale: "en-NZ",
    dateStyle: "short",
    ...options,
  };

  return new Intl.DateTimeFormat(defaultOptions.locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(date);
};

export const formatTime = (
  date: Date,
  options: TimeFormatOptions = {}
): string => {
  const defaultOptions: TimeFormatOptions = {
    locale: "en-NZ",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    ...options,
  };

  return new Intl.DateTimeFormat(defaultOptions.locale, {
    hour: defaultOptions.hour,
    minute: defaultOptions.minute,
    hour12: defaultOptions.hour12,
  })
    .format(date)
    .toLowerCase();
};

export const formatTimeRange = (
  start: Date,
  end: Date,
  options: TimeFormatOptions = {}
): string => {
  const startTime = formatTime(start, options);
  const endTime = formatTime(end, options);

  return `${startTime} - ${endTime}`;
};

export const formatDateTime = (
  date: Date,
  options: DateTimeFormatOptions = {}
): string => {
  const defaultOptions: DateTimeFormatOptions = {
    locale: "en-NZ",
    dateStyle: "short",
    timeStyle: "short",
    ...options,
  };

  return new Intl.DateTimeFormat(defaultOptions.locale, {
    dateStyle: defaultOptions.dateStyle,
    timeStyle: defaultOptions.timeStyle,
  }).format(date);
};
